// Cancellation is routine — a channel switch aborts everything in flight — so callers drop this rather than report it.
export class AbortError extends Error {
  public constructor() {
    super('Operation cancelled');
    this.name = 'AbortError';
  }

  public static throwIfAborted(signal?: AbortSignal): void {
    if (signal?.aborted) {
      throw new AbortError();
    }
  }
}
